import { Col, Row } from "antd";
import BackgroundWrapper from "../Global/Atomics/BackgroundWrapper";
import { useForm } from "react-hook-form";
import { useAuthContext } from "../../contexts/AuthContext";
import styled from "styled-components";
import { useEffect } from "react";
import { Icon } from '@synergy/icons';
import Button from "../Global/Atomics/Button";
import { Avatar } from "../Global/Atomics/Avatar";

const USERNAME_ID = 'username';
const PASSWORD_ID = 'password';

const BottomBorder = styled.div`
    position: relative;
    bottom: 0;
    background-color: transparent;
    border-bottom: 5px solid #86BC25;
    margin-top: auto;
`;

export function LoginScreen() {
    const { handleSubmit, watch, trigger, formState: { isValid } } = useForm({
        mode: 'onTouched',
        defaultValues: {
            [USERNAME_ID]: '',
            [PASSWORD_ID]: '',
        }
    })
    const { login, isLogging, isError } = useAuthContext();

    // Trigger validation when user starts to write password
    const watchPwd = watch(PASSWORD_ID);
    useEffect(() => {
        if (watchPwd) {
            trigger([USERNAME_ID, PASSWORD_ID]);
        }
    }, [trigger, watchPwd]);

    return (
        <>
            <BackgroundWrapper circleTop circleTopColor='#FFF'>

                {/* LOGO */}
                <Row>
                    <Col>
                        <div style={{ padding: '25px 0px 0px 70px' }} className="deloitte">
                            <Icon icon='NovaLogo' color="coolgray-10" width={100} height={50} />
                        </div>
                    </Col>
                </Row>

                {/* WELCOME TEXT */}
                <Row>
                    <Col>
                        <div style={{ margin: '80px 0px 0px 70px' }}>
                            <h1 style={{ fontFamily: 'Inter,sans-serif', fontWeight: 'normal', margin: '0', fontSize: 'x-large' }}>Bem-vindo(a) à APP do Videowall</h1>
                            <h1 style={{ fontFamily: 'Inter,sans-serif', color: '#25763C', fontSize: 'x-large' }}>Smart Campus Campolide</h1>
                        </div>
                    </Col>
                </Row>

                <Row style={{ top: '40%', alignSelf: 'center', position: 'absolute' }}>
                    <Col>
                        <div style={{ margin: "16px auto 24px auto", padding: "0 0 8px 0", textAlign: "center" }}>
                            <h2 style={{ margin: 0 }}>Pertence à comunidade da NOVA?</h2>
                            <p style={{ margin: 0 }}>Registe-se com o seu e-mail institucional</p>
                        </div>
                        <form onSubmit={handleSubmit(() => login())}>

                            {/* SUBMIT */}
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <Button id="login-btn" type="submit" variant="primary-black" size="m" disabled={!isValid} >
                                    Login NOVA
                                </Button>
                            </div>

                            {/* Error message */}
                            {isError &&
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <Avatar border="none" bg="error-4" size={26}>
                                        <Icon iconsize='sm' icon='Error' color="red" width={12} height={12} />
                                    </Avatar>
                                    <div sytle={{ color: '#D44333' }}>
                                        Ups! Algo correu mal.
                                    </div>
                                </div>
                            }
                        </form>
                    </Col>
                </Row>

                <BottomBorder as="footer" id="main-footer">
                    <div style={{ padding: "48px 0px 24px 60px", float: "left" }}>
                        <Icon iconsize='sm' icon='BrandLogo' color="coolgray-10" width={100} height={35} />
                    </div>
                </BottomBorder>
            </BackgroundWrapper>
        </>
    )
};